// troubleshooting
export const URL_AVOIDING_EVAL = 'troubleshooting/#avoiding-eval';
export const URL_NAME_IS_NOT_EXPORTED = 'troubleshooting/#error-name-is-not-exported-by-module';
export const URL_THIS_IS_UNDEFINED = 'troubleshooting/#error-this-is-undefined';
export const URL_TREATING_MODULE_AS_EXTERNAL_DEPENDENCY =
	'troubleshooting/#warning-treating-module-as-external-dependency';
export const URL_SOURCEMAP_IS_LIKELY_TO_BE_INCORRECT =
	'troubleshooting/#warning-sourcemap-is-likely-to-be-incorrect';

// configuration-options
export const URL_JSX = 'configuration-options/#jsx';
export const URL_MAXPARALLELFILEOPS = 'configuration-options/#maxparallelfileops';
export const URL_OUTPUT_AMD_ID = 'configuration-options/#output-amd-id';
export const URL_OUTPUT_AMD_BASEPATH = 'configuration-options/#output-amd-basepath';
export const URL_OUTPUT_DIR = 'configuration-options/#output-dir';
export const URL_OUTPUT_EXPORTS = 'configuration-options/#output-exports';
export const URL_OUTPUT_EXTEND = 'configuration-options/#output-extend';
export const URL_OUTPUT_EXTERNALIMPORTATTRIBUTES =
	'configuration-options/#output-externalimportattributes';
export const URL_OUTPUT_FORMAT = 'configuration-options/#output-format';
export const URL_OUTPUT_GENERATEDCODE = 'configuration-options/#output-generatedcode';
export const URL_OUTPUT_GENERATEDCODE_SYMBOLS =
	'configuration-options/#output-generatedcode-symbols';
export const URL_OUTPUT_GLOBALS = 'configuration-options/#output-globals';
export const URL_OUTPUT_INLINEDYNAMICIMPORTS = 'configuration-options/#output-inlinedynamicimports';
export const URL_OUTPUT_INTEROP = 'configuration-options/#output-interop';
export const URL_OUTPUT_MANUALCHUNKS = 'configuration-options/#output-manualchunks';
export const URL_OUTPUT_NAME = 'configuration-options/#output-name';
export const URL_OUTPUT_PRESERVEMODULES = 'configuration-options/#output-preservemodules';
export const URL_OUTPUT_SOURCEMAPBASEURL = 'configuration-options/#output-sourcemapbaseurl';
export const URL_OUTPUT_SOURCEMAPFILE = 'configuration-options/#output-sourcemapfile';
export const URL_PRESERVEENTRYSIGNATURES = 'configuration-options/#preserveentrysignatures';
export const URL_TREESHAKE = 'configuration-options/#treeshake';
export const URL_TREESHAKE_PURE = 'configuration-options/#pure';
export const URL_TREESHAKE_NOSIDEEFFECTS = 'configuration-options/#no-side-effects';
export const URL_TREESHAKE_MODULESIDEEFFECTS = 'configuration-options/#treeshake-modulesideeffects';
export const URL_WATCH = 'configuration-options/#watch';

// command-line-interface
export const URL_BUNDLE_CONFIG_AS_CJS = 'command-line-interface/#bundleconfigascjs';
export const URL_CONFIGURATION_FILES = 'command-line-interface/#configuration-files';

// plugin-development
export const URL_A_SIMPLE_EXAMPLE = 'plugin-development/#a-simple-example';
export const URL_GENERATEBUNDLE = 'plugin-development/#generatebundle';
export const URL_RENDERDYNAMICIMPORT = 'plugin-development/#renderdynamicimport';
export const URL_THIS_GETMODULEIDS = 'plugin-development/#this-getmoduleids';
export const URL_THIS_GETMODULEINFO = 'plugin-development/#this-getmoduleinfo';
